import type { Dictionary, ErrorsMessages } from '../models'

import { PlayErrorReasonEnum } from '@empathybroker/tsclient-play/dist/enums/play-error-reason.enum'

import { LocaleEnum } from '../enums'

const ERRORS_MESSAGES_EN: ErrorsMessages = {
  400: {
    title: 'Bad request',
    message: 'Server could not understand the request due to malformed or illegal syntax.',
    reasons: {
      [PlayErrorReasonEnum.DUPLICATED]: 'This element conflicts with some of the existing ones',
    },
  },
  401: {
    title: 'Unauthorized',
    message: 'Authorization is required to access the specified resource.',
  },
  403: {
    title: 'Forbidden',
    message: "You don't have permission to access the specified resource.",
  },
  404: {
    title: 'Not found',
    message: 'The resource you requested was not found.',
  },
  409: {
    title: 'Conflict',
    message: 'The resource you submitted conflicts with the current state of the server.',
  },
  500: {
    title: 'Internal server error',
    message:
      'An error occurred while processing this request. Please try again later or contact support.',
  },
  503: {
    title: 'Service unavailable',
    message: 'The server is temporarily unable to process your request. Please try again later.',
  },
  default: {
    title: 'Error {code}',
    message: 'An unexpected error ocurred. Please try again later or contact support.',
  },
}

const ERRORS_MESSAGES_ES: ErrorsMessages = {
  400: {
    title: 'Petición incorrecta',
    message: 'El servidor no pudo entender la petición debido a una sintaxis incorrecta o ilegal.',
    reasons: {
      [PlayErrorReasonEnum.DUPLICATED]:
        'Este elemento entra en conflicto con alguno de los ya existentes',
    },
  },
  401: {
    title: 'No autorizado',
    message: 'Se requiere autorización para acceder al recurso especificado.',
  },
  403: {
    title: 'Prohibido',
    message: 'No tiene permiso para acceder al recurso especificado.',
  },
  404: {
    title: 'No encontrado',
    message: 'No se encontró el recurso solicitado.',
  },
  409: {
    title: 'Conflicto',
    message: 'El recurso enviado entra en conflicto con el estado actual del servidor.',
  },
  500: {
    title: 'Error interno del servidor',
    message:
      'Se produjo un error al procesar esta petición. Vuelva a intentarlo más tarde o póngase en contacto con soporte.',
  },
  503: {
    title: 'Servicio no disponible',
    message:
      'El servidor no puede procesar su petición temporalmente. Por favor, inténtelo de nuevo más tarde.',
  },
  default: {
    title: 'Error {code}',
    message:
      'Se produjo un error inesperado. Vuelva a intentarlo más tarde o póngase en contacto con soporte.',
  },
}

export const ERRORS_MESSAGES: Dictionary<{ errors: ErrorsMessages }> = {
  [LocaleEnum.ENGLISH]: {
    errors: ERRORS_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    errors: ERRORS_MESSAGES_ES,
  },
}
